import {
  Box,
  Button,
  HStack,
  Icon,
  IconButton,
  Input,
  Stack,
  createIcon,
} from '@chakra-ui/react';
import Accordion1 from '../../../../../../core/components/accordion/Accordion1';
import ValueCheckbox from '../../../../../../sheet/components/grid/filterDropdown/filterAtoms/ValueCheckbox';
import { IconSetsValidation } from '../../../../../../sheet/types';
import { UpdateRule } from '../useCreateDataValidation';
import IconSetPicker from './IconSetPicker';
import { SVGIconDetail } from '../../../../../../sheet/constants/icons/icons';
import { IconType } from 'react-icons';
import { MdDelete, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { createCustomIcon } from '../../../../../../core/utils/view/createCustomIcon';
import { getIconSetFromCategory } from '../../../../../../sheet/helpers/cellView/iconHelpers';
import IconSetTypePicker from './IconSetTypePicker';

interface IconSetEditorProps {
  rule: IconSetsValidation;
  updateRule: UpdateRule;
}
const IconSetEditor = ({ rule, updateRule }: IconSetEditorProps) => {
  const iconSets = getIconSetFromCategory(rule.category);
  const isDisabled = !rule.useCustomIcons;

  const renderIconSets = () =>
    iconSets?.map(({ value, viewBoxSize, shapes }) => {
      const key = value.toString();
      const CustomIcon = createCustomIcon(viewBoxSize, shapes, key);

      return <Icon key={key} as={CustomIcon} aria-label={key} />;
    });

  const Header = (
    <Box as="span" flex="1" textAlign="left">
      <HStack justifyContent="center" spacing="4">
        {renderIconSets()}
      </HStack>
    </Box>
  );

  const iconSelector = (
    { value, shapes, viewBoxSize }: SVGIconDetail,
    index: number
  ) => {
    const CustomIcon = createCustomIcon(viewBoxSize, shapes, value.toString());
    return (
      <HStack key={`${value}-${index}`}>
        <Button
          leftIcon={<CustomIcon />}
          rightIcon={<MdOutlineKeyboardArrowDown />}
          rounded="2xl"
          isDisabled={isDisabled}
          padding="0px 20px"
          background="Background"
        />
        <Input
          value={value}
          background="Background"
          onChange={() => {}}
          rounded="2xl"
          disabled={isDisabled}
        />
        <Input
          placeholder="description"
          background="Background"
          onChange={() => {}}
          rounded="2xl"
          disabled={isDisabled}
        />
        <IconButton
          isRound
          aria-label="delete-icon"
          icon={<MdDelete />}
          isDisabled={isDisabled}
          colorScheme="red"
        />
      </HStack>
    );
  };

  const renderIconsList = () =>
    iconSets?.map((iconDetail, index) => iconSelector(iconDetail, index));

  const Panel = <Stack>{renderIconsList()}</Stack>;

  const showIconSetCategories = () => {
    return <IconSetPicker category={rule.category} updateRule={updateRule} />;
  };

  const renderCustomIconsCheckbox = () => (
    <ValueCheckbox
      style={{ height: '32px', fontSize: '13px' }}
      visibleValue="Use Custom Icons"
      isSelected={!!rule.useCustomIcons}
      onSelect={(_, _1, val) => updateRule({ useCustomIcons: val })}
    />
  );

  const renderIconSetCategories = () => (
    <HStack>
      {showIconSetCategories()}
      {renderCustomIconsCheckbox()}
    </HStack>
  );

  const renderIconSetTypePicker = () => (
    <IconSetTypePicker setType={rule.setType} updateRule={updateRule} />
  );

  return (
    <>
      {renderIconSetCategories()}
      {renderIconSetTypePicker()}
      <Accordion1 Header={Header} Panel={Panel} />
    </>
  );
};

export default IconSetEditor;

// export function TbTruckLoading (props) {
//   return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}},{"tag":"path","attr":{"d":"M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"}},{"tag":"path","attr":{"d":"M9 6m0 3a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3z"}},{"tag":"path","attr":{"d":"M9 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"}},{"tag":"path","attr":{"d":"M18 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"}}]})(props);
// };
